import React, { ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ReferencedWorkDTO } from '../../../api/core';
import {
  referencedWorkToSelectedWork,
  SelectedWork,
  selectedWorkToReferencedWork,
  WorkSuggester,
} from '../../edit/components/suggester/WorkSuggester';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledWorkSuggesterProps extends LabelledProps {
  value: ReferencedWorkDTO[];
  onChange: (refs: ReferencedWorkDTO[]) => void;
  pattern?: string;
  autoFocus?: boolean;
  multiple: boolean;
  border?: 'border-noround' | 'border-noround-right';
}

export const LabelledWorkSuggester = (props: LabelledWorkSuggesterProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <WorkSuggester
        value={props.value.map(referencedWorkToSelectedWork)}
        autoFocus={props.autoFocus}
        inputId={props.id}
        required={props.permissions?.required || props.required}
        disabled={disabled}
        multiple={props.multiple}
        validation={props.validation}
        border={props.border}
        onChange={(refs: SelectedWork[]): void => props.onChange(refs.map(selectedWorkToReferencedWork))}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
      />
    </Labelled>
  );
};
